// extracted by mini-css-extract-plugin
export default {"main":"Main_main__rq3D6","flareAnimation":"Main_flareAnimation__A16xO","shine":"Main_shine__QZO30"};